import { createSlice } from "@reduxjs/toolkit";

interface UpdateMetrics {
  data: null;
  users: number;
  subscribers: number;
  reports: { guest: number; subscribers: number };
  revenue: number;
}

const initialState: UpdateMetrics = {
  data: null,
  users: 0,
  subscribers: 0,
  reports: { guest: 0, subscribers: 0 },
  revenue: 1326031,
};
const metricsSlice = createSlice({
  name: "metricsSlice",
  initialState,
  reducers: {
    updateMetricsAction: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { updateMetricsAction } = metricsSlice.actions;
export default metricsSlice.reducer;
